<template>
  <div>
    <a-tabs v-model="activeKey" @change="tabsChange">
      <a-tab-pane key="1" tab="批量翻译"> </a-tab-pane>
      <a-tab-pane key="2" tab="翻译日志"> </a-tab-pane>
      <a-tab-pane key="4" tab="改写日志"> </a-tab-pane>
      <a-tab-pane key="3" tab="句式管理"> </a-tab-pane>

    </a-tabs>
    <Search
      :activeKey="activeKey"
      :class="{ hide: activeKey === '3' }"
      ref="searchRef"
      @customerIdChange="customerIdChange"
    />
    <a-tabs v-model="activeKey2" type="card" @change="tabsChangeSecond">
      <a-tab-pane
          v-if="activeKey != '4'"
        v-for="item in (activeKey === '3' ? promptTabList : tabList)"
        :key="item.key"
        :tab="item.tab"
      ></a-tab-pane>
      <a-tab-pane
          v-if="activeKey === '4'"
          v-for="item in RewriteLogsTabList"
          :key="item.key"
          :tab="item.tab"
      ></a-tab-pane>
    </a-tabs>
    <ProductClassTranslateAll
      v-if="activeKey === '1' && activeKey2 === 'ProductClass'"
      ref="TranslateAll"
      @resetSeach="resetSeach"
    />
    <ProductClassTranslationLog
      v-if="activeKey === '2' && activeKey2 === 'ProductClass'"
      ref="TranslationLog"
      @resetSeach="resetSeach"
    />
    <ProductClassPrompt
      v-if="activeKey === '3' && activeKey2 === 'ProductClass'"
      ref="Prompt"
    />
    <ProductClassPrompts
        v-if="activeKey === '3' && activeKey2 === 'ProductClass1'"
        ref="Prompt"
    />
    <ProductClassRewriteLogs
        v-if="activeKey === '4' && activeKey2 === 'ProductClass'"
        ref="RewriteLogs"
        @resetSeach="resetSeach"
    />
    <ProductListTranslateAll
      v-if="activeKey === '1' && activeKey2 === 'ProductList'"
      ref="TranslateAll"
      @resetSeach="resetSeach"
    />
    <ProductListTranslationLog
      v-if="activeKey === '2' && activeKey2 === 'ProductList'"
      ref="TranslationLog"
      @resetSeach="resetSeach"
    />
    <ProductListPrompt
      v-if="activeKey === '3' && activeKey2 === 'ProductList' "
      ref="Prompt"
    />
    <ProductListPrompts
        v-if="activeKey === '3' && activeKey2 === 'ProductList1'"
        ref="Prompt"
    />
    <ProductListRewriteLogs
        v-if="activeKey === '4' && activeKey2 === 'ProductList'"
        ref="RewriteLogs"
        @resetSeach="resetSeach"
    />
    <NewsListTranslateAll
      v-if="activeKey === '1' && activeKey2 === 'NewsList'"
      ref="TranslateAll"
      @resetSeach="resetSeach"
    />
    <NewsListTranslationLog
      v-if="activeKey === '2' && activeKey2 === 'NewsList'"
      ref="TranslationLog"
      @resetSeach="resetSeach"
    />
    <NewsListPrompt
      v-if="activeKey === '3' && activeKey2 === 'NewsList'"
      ref="Prompt"
    />
    <CaseListTranslateAll
      v-if="activeKey === '1' && activeKey2 === 'CaseList'"
      ref="TranslateAll"
      @resetSeach="resetSeach"
    />
    <CaseListTranslationLog
      v-if="activeKey === '2' && activeKey2 === 'CaseList'"
      ref="TranslationLog"
      @resetSeach="resetSeach"
    />
    <CaseListPrompt
      v-if="activeKey === '3' && activeKey2 === 'CaseList'"
      ref="Prompt"
    />
    <CaseListPrompts
        v-if="activeKey === '3' && activeKey2 === 'CaseList1'"
        ref="Prompt"
    />
    <CaseListRewriteLogs
        v-if="activeKey === '4' && activeKey2 === 'CaseList'"
        ref="RewriteLogs"
        @resetSeach="resetSeach"
    />
    <NewsClassTranslateAll
      v-if="activeKey === '1' && activeKey2 === 'NewsClass'"
      ref="TranslateAll"
      @resetSeach="resetSeach"
    />
    <NewsClassTranslationLog
      v-if="activeKey === '2' && activeKey2 === 'NewsClass'"
      ref="TranslationLog"
      @resetSeach="resetSeach"
    />
    <CaseClassTranslateAll
      v-if="activeKey === '1' && activeKey2 === 'CaseClass'"
      ref="TranslateAll"
      @resetSeach="resetSeach"
    />
    <CaseClassTranslationLog
      v-if="activeKey === '2' && activeKey2 === 'CaseClass'"
      ref="TranslationLog"
      @resetSeach="resetSeach"
    />
    <CaseClassPrompt
        v-if="activeKey === '3' && activeKey2 === 'CaseClass'"
        ref="Prompt"
    />
    <CaseClassRewriteLogs
        v-if="activeKey === '4' && activeKey2 === 'CaseClass'"
        ref="RewriteLogs"
        @resetSeach="resetSeach"
    />
    <SinglePageClassTranslateAll
      v-if="activeKey === '1' && activeKey2 === 'SinglePageClass'"
      ref="TranslateAll"
      @resetSeach="resetSeach"
    />
    <SinglePageClassTranslationLog
      v-if="activeKey === '2' && activeKey2 === 'SinglePageClass'"
      ref="TranslationLog"
      @resetSeach="resetSeach"
    />
    <SinglePageClassPrompt
        v-if="activeKey === '3' && activeKey2 === 'SinglePageClass'"
        ref="Prompt"
    />
    <SinglePageClassRewriteLogs
        v-if="activeKey === '4' && activeKey2 === 'SinglePageClass'"
        ref="RewriteLogs"
        @resetSeach="resetSeach"
    />
    <SinglePageListTranslateAll
      v-if="activeKey === '1' && activeKey2 === 'SinglePageList'"
      ref="TranslateAll"
      @resetSeach="resetSeach"
    />
    <SinglePageListTranslationLog
      v-if="activeKey === '2' && activeKey2 === 'SinglePageList'"
      ref="TranslationLog"
      @resetSeach="resetSeach"
    />
    <SinglePageListPrompt
        v-if="activeKey === '3' && activeKey2 === 'SinglePageList'"
        ref="Prompt"
    />
    <SinglePageListRewriteLogs
        v-if="activeKey === '4' && activeKey2 === 'SinglePageList'"
        ref="RewriteLogs"
        @resetSeach="resetSeach"
    />
    <FAQTranslateAll
      v-if="activeKey === '1' && activeKey2 === 'FAQ'"
      ref="TranslateAll"
      @resetSeach="resetSeach"
    />
    <FAQTranslationLog
      v-if="activeKey === '2' && activeKey2 === 'FAQ'"
      ref="TranslationLog"
    />
    <DownloadClassTranslateAll
      v-if="activeKey === '1' && activeKey2 === 'DownloadClass'"
      ref="TranslateAll"
      @resetSeach="resetSeach"
    />
    <DownloadClassTranslationLog
      v-if="activeKey === '2' && activeKey2 === 'DownloadClass'"
      ref="TranslationLog"
      @resetSeach="resetSeach"
    />
    <DownloadListTranslateAll
      v-if="activeKey === '1' && activeKey2 === 'DownloadList'"
      ref="TranslateAll"
      @resetSeach="resetSeach"
    />
    <DownloadListTranslationLog
      v-if="activeKey === '2' && activeKey2 === 'DownloadList'"
      ref="TranslationLog"
      @resetSeach="resetSeach"
    />
    <CertificateTranslateAll
      v-if="activeKey === '1' && activeKey2 === 'certificate'"
      ref="TranslateAll"
      @resetSeach="resetSeach"
    />
    <CertificateTranslationLog
      v-if="activeKey === '2' && activeKey2 === 'certificate'"
      ref="TranslationLog"
      @resetSeach="resetSeach"
    />
    <VideoTranslateAll
      v-if="activeKey === '1' && activeKey2 === 'video'"
      ref="TranslateAll"
      @resetSeach="resetSeach"
    />
    <VideoTranslationLog
      v-if="activeKey === '2' && activeKey2 === 'video'"
      ref="TranslationLog"
      @resetSeach="resetSeach"
    />
    <SeoTranslateAll
      v-if="activeKey === '1' && activeKey2 === 'seo'"
      ref="TranslateAll"
      @resetSeach="resetSeach"
    />
    <SeoTranslationLog
      v-if="activeKey === '2' && activeKey2 === 'seo'"
      ref="TranslationLog"
      @resetSeach="resetSeach"
    />
    <ProductAttributesTranslateAll
      v-if="activeKey === '1' && activeKey2 === 'ProductAttributes'"
      ref="TranslateAll"
      @resetSeach="resetSeach"
    />
    <ProductAttributesTranslationLog
      v-if="activeKey === '2' && activeKey2 === 'ProductAttributes'"
      ref="TranslationLog"
      @resetSeach="resetSeach"
    />
    <TranslationOtherTranslateAll
      v-if="activeKey === '1' && activeKey2 === 'TranslationOther'"
      ref="TranslateAll"
      @resetSeach="resetSeach"
    />
    <TranslationOtherTranslationLog
      v-if="activeKey === '2' && activeKey2 === 'TranslationOther'"
      ref="TranslationLog"
      @resetSeach="resetSeach"
    />
  </div>
</template>

<script>
import Search from "./components/Search";
import ProductClassTranslateAll from "../ProductClass/components/translateAll";
import ProductClassTranslationLog from "../ProductClass/components/translationLog";
import ProductClassPrompt from "../ProductClass/components/prompt/index.vue";
import ProductClassPrompts from "../ProductClass/components/prompt/index2.vue";
import ProductClassRewriteLogs from "../ProductClass/components/rewritelogs";
import ProductListTranslateAll from "../BatchTranslationList/components/translateAll";
import ProductListTranslationLog from "../BatchTranslationList/components/translationLog";
import ProductListPrompt from "../BatchTranslationList/components/prompt/index.vue";
import ProductListPrompts from "../BatchTranslationList/components/prompt/index2.vue";
import ProductListRewriteLogs from "../BatchTranslationList/components/rewritelogs";
import NewsListTranslateAll from "../NewsList/components/translateAll";
import NewsListTranslationLog from "../NewsList/components/translationLog";
import NewsListPrompt from "../NewsList/components/prompt/index.vue";
import CaseListTranslateAll from "../CaseList/components/translateAll";
import CaseListTranslationLog from "../CaseList/components/translationLog";
import CaseListPrompt from "../CaseList/components/prompt/index.vue";
import CaseListPrompts from "../CaseList/components/prompt/index2.vue";
import CaseListRewriteLogs from "../CaseList/components/rewritelogs";
import NewsClassTranslateAll from "../NewsClass/components/translateAll";
import NewsClassTranslationLog from "../NewsClass/components/translationLog";
import CaseClassTranslateAll from "../CaseClass/components/translateAll";
import CaseClassTranslationLog from "../CaseClass/components/translationLog";
import CaseClassPrompt from "../CaseClass/components/prompt/index.vue";
import CaseClassRewriteLogs from "../CaseClass/components/rewritelogs";
import SinglePageClassTranslateAll from "../SinglePageClass/components/translateAll";
import SinglePageClassTranslationLog from "../SinglePageClass/components/translationLog";
import SinglePageClassPrompt from "../SinglePageClass/components/prompt/index.vue";
import SinglePageClassRewriteLogs from "../SinglePageClass/components/rewritelogs";
import SinglePageListTranslateAll from "../SinglePageList/components/translateAll";
import SinglePageListTranslationLog from "../SinglePageList/components/translationLog";
import SinglePageListPrompt from "../SinglePageList/components/prompt/index.vue";
import SinglePageListRewriteLogs from "../SinglePageList/components/rewritelogs";
import FAQTranslateAll from "../FAQ/components/translateAll";
import FAQTranslationLog from "../FAQ/components/translationLog";
import DownloadClassTranslateAll from "../DownloadClass/components/translateAll";
import DownloadClassTranslationLog from "../DownloadClass/components/translationLog";
import DownloadListTranslateAll from "../DownloadList/components/translateAll";
import DownloadListTranslationLog from "../DownloadList/components/translationLog";
import CertificateTranslateAll from "../certificate/components/translateAll";
import CertificateTranslationLog from "../certificate/components/translationLog";
import VideoTranslateAll from "../video/components/translateAll";
import VideoTranslationLog from "../video/components/translationLog";
import SeoTranslateAll from "../seo/components/translateAll";
import SeoTranslationLog from "../seo/components/translationLog";
import ProductAttributesTranslateAll from "../ProductAttributes/components/translateAll";
import ProductAttributesTranslationLog from "../ProductAttributes/components/translationLog";
import TranslationOtherTranslateAll from "../Other/components/translateAll";
import TranslationOtherTranslationLog from "../Other/components/translationLog";

export default {
  name: "index",
  data() {
    return {
      activeKey: "1",
      activeKey2: "ProductClass",
      mode: "top",
      tabList: [
        {
          key: "ProductClass",
          tab: "产品分类"
        },
        {
          key: "ProductList",
          tab: "产品"
        },
        {
          key: "NewsList",
          tab: "新闻"
        },
        {
          key: "CaseList",
          tab: "案例"
        },
        {
          key: "NewsClass",
          tab: "新闻分类"
        },
        {
          key: "CaseClass",
          tab: "案例分类"
        },
        {
          key: "SinglePageClass",
          tab: "单页分类"
        },
        {
          key: "SinglePageList",
          tab: "单页列表"
        },
        {
          key: "FAQ",
          tab: "FAQ"
        },
        {
          key: "DownloadClass",
          tab: "下载分类"
        },
        {
          key: "DownloadList",
          tab: "下载列表"
        },
        {
          key: "certificate",
          tab: "证书"
        },
        {
          key: "video",
          tab: "视频"
        },
        {
          key: "seo",
          tab: "导航seo"
        },
        {
          key: "ProductAttributes",
          tab: "产品属性"
        },
        {
          key: "TranslationOther",
          tab: "聚合页面"
        }
      ],
      RewriteLogsTabList: [
        {
          key: "ProductClass",
          tab: "产品分类"
        },
        {
          key: "ProductList",
          tab: "产品"
        },
        {
          key: "CaseList",
          tab: "案例"
        },
        {
          key: "CaseClass",
          tab: "案例分类"
        },
        // {
        //   key: "SinglePageClass",
        //   tab: "单页分类"
        // },
        {
          key: "SinglePageList",
          tab: "单页列表"
        },
      ],
      promptTabList: [
        {
          key: "ProductClass",
          tab: "产品分类"
        },
        {
          key: "ProductList",
          tab: "产品"
        },
        {
          key: "NewsList",
          tab: "新闻"
        },
        {
          key: "CaseList",
          tab: "案例"
        },
        {
          key: "ProductList1",
          tab: "产品改写"
        },
        {
          key: "ProductClass1",
          tab: "产品分类改写"
        },
        {
          key: "CaseList1",
          tab: "案例改写"
        },
        {
          key: "CaseClass",
          tab: "案例分类改写"
        },
        // {
        //   key: "SinglePageClass",
        //   tab: "单页分类改写"
        // },
        {
          key: "SinglePageList",
          tab: "单页列表改写"
        },
      ]
    };
  },
  components: {
    Search,
    ProductClassTranslateAll,
    ProductClassTranslationLog,
    ProductClassPrompt,
    ProductClassPrompts,
    ProductClassRewriteLogs,
    ProductListTranslateAll,
    ProductListTranslationLog,
    ProductListPrompt,
    ProductListPrompts,
    ProductListRewriteLogs,
    NewsListTranslateAll,
    NewsListTranslationLog,
    NewsListPrompt,
    CaseListTranslateAll,
    CaseListTranslationLog,
    CaseListPrompt,
    CaseListPrompts,
    CaseListRewriteLogs,
    NewsClassTranslateAll,
    NewsClassTranslationLog,
    CaseClassTranslateAll,
    CaseClassTranslationLog,
    CaseClassPrompt,
    CaseClassRewriteLogs,
    SinglePageClassTranslateAll,
    SinglePageClassTranslationLog,
    SinglePageClassPrompt,
    SinglePageClassRewriteLogs,
    SinglePageListTranslateAll,
    SinglePageListTranslationLog,
    SinglePageListPrompt,
    SinglePageListRewriteLogs,
    FAQTranslateAll,
    FAQTranslationLog,
    DownloadClassTranslateAll,
    DownloadClassTranslationLog,
    DownloadListTranslateAll,
    DownloadListTranslationLog,
    CertificateTranslateAll,
    CertificateTranslationLog,
    VideoTranslateAll,
    VideoTranslationLog,
    SeoTranslateAll,
    SeoTranslationLog,
    ProductAttributesTranslateAll,
    ProductAttributesTranslationLog,
    TranslationOtherTranslateAll,
    TranslationOtherTranslationLog
  },
  created() {
    this.$store.state.adminleftnavnum = "/BatchTranslation/ColumnTranslation"; //设置左侧导航2-2 active
  },
  methods: {
    tabsChange(data) {
      this.activeKey2 = "ProductClass";
      console.log(this.$refs["searchRef"].seach.a_customer_id)
      if (data == 1) {
        if (this.$refs["searchRef"].seach.a_customer_id) {
          setTimeout(() => {
            this.$refs["TranslateAll"].seach.a_customer_id = this.$refs[
                "searchRef"
                ].seach.a_customer_id;
            this.$refs["TranslateAll"].getList();
          }, 300);
        }
      } else if (data == 4) {
        if (this.$refs["searchRef"].seach.a_customer_id) {
          setTimeout(() => {
            this.$refs["RewriteLogs"].seach.a_customer_id = this.$refs[
                "searchRef"
                ].seach.a_customer_id;
            this.$refs["RewriteLogs"].getList();
          }, 300);
        }
      } else if (data == 2) {
        if (this.$refs["searchRef"].seach.a_customer_id) {
          setTimeout(() => {
            this.$refs["TranslationLog"].seach.a_customer_id = this.$refs[
                "searchRef"
                ].seach.a_customer_id;
            this.$refs["TranslationLog"].getList();
          }, 300);
        }
      }
    },
    tabsChangeSecond(data) {
      let _that = this;
      if (this.$refs["searchRef"].seach.a_customer_id) {
        if (this.activeKey == 1) {
          setTimeout(() => {
            this.$refs["TranslateAll"].seach.a_customer_id = this.$refs[
                "searchRef"
                ].seach.a_customer_id;
            if(_that.activeKey2 == "ProductList" || _that.activeKey2 == "NewsList" || _that.activeKey2 == "CaseList" || _that.activeKey2 == "SinglePageList" || _that.activeKey2 == "DownloadList") {
              _that.$refs["TranslateAll"].getClass(_that.$refs["searchRef"].seach.a_customer_id);
            }
            this.$refs["TranslateAll"].getList();
          }, 300);
        }
        if (this.activeKey == 2) {
          setTimeout(() => {
            this.$refs["TranslationLog"].seach.a_customer_id = this.$refs[
                "searchRef"
                ].seach.a_customer_id;
            this.$refs["TranslationLog"].getList();
          }, 300);
        }
        if (this.activeKey == 4) {
          setTimeout(() => {
            this.$refs["RewriteLogs"].seach.a_customer_id = this.$refs[
                "searchRef"
                ].seach.a_customer_id;
            this.$refs["RewriteLogs"].getList();
          }, 300);
        }
      }
    },
    customerIdChange(value) {
      let _that = this;
      console.log(value)
      if (this.activeKey == 1) {
        this.$refs["TranslateAll"].seach.a_customer_id = value;

        if(_that.activeKey2 == "ProductList" || _that.activeKey2 == "NewsList" || _that.activeKey2 == "CaseList" || _that.activeKey2 == "SinglePageList" || _that.activeKey2 == "DownloadList") {
          _that.$refs["TranslateAll"].getClass(value);
        }
        this.$refs["TranslateAll"].getList();
      } else if (this.activeKey == 4) {
        this.$refs["RewriteLogs"].seach.a_customer_id = value;
        this.$refs["RewriteLogs"].seach.a_customer_id = this.$refs[
            "searchRef"
            ].seach.a_customer_id;
        this.$refs["RewriteLogs"].getList();
      } else {
        this.$refs["TranslationLog"].seach.a_customer_id = value;
        this.$refs["TranslationLog"].seach.a_customer_id = this.$refs[
            "searchRef"
            ].seach.a_customer_id;
        this.$refs["TranslationLog"].getList();
      }
    },
    resetSeach() {
      // this.$refs["searchRef"].seach.a_customer_id = "";
      // this.$refs["searchRef"].message = "";
    }
  }
};
</script>

<style scoped>
.hide{display: none}
</style>
